module.exports = "<div class=row style=position:relative;min-height:400px> <div class=col-md-12> <div class=\"\"> <product-list products=$ctrl.items></product-list> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/store-carousel-list/store-carousel-list.template.html
// module id = 128
// module chunks = 0